import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=3864c434&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=ts"
export * from "./uploadFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3864c434",
  null
  
)

export default component.exports